import script from "./VWAP.vue?vue&type=script&lang=js"
export * from "./VWAP.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__